import React from "react";
import AdminHeader from "./AdminHeader";
import AdminNavbar from "./AdminNavbar";
const Abetlistlive = () => {
  return (
    <div>
      <AdminHeader />
      <AdminNavbar />
      <div className="commision fixed_width h-[100vh]  bg-[#f0ece1]  ">
        <div className="flex-col flex justify-center ">
          <h2 className="font-bold mt-4  text-black px-[40px]">Check Result</h2>
          <div className="flex items-center justify-center">
            <div className="bg-[#e9f1f6c9] border-b-2 border-[#498daf] shadow-md   w-[98%]">
              <div className="commision_bos   px-5 py-3">
                <input
                  className="form-check-input mr-2"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                />
                <label
                  className="form-check-label mr-3"
                  for="flexRadioDefault1"
                >
                  Soccer
                </label>
                <input
                  className="form-check-input mr-2"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                />
                <label
                  className="form-check-label mr-3"
                  for="flexRadioDefault1"
                >
                  Tennis
                </label>
                <input
                  className="form-check-input mr-2"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                />
                <label
                  className="form-check-label mr-3"
                  for="flexRadioDefault1"
                >
                  Cricket
                </label>
                <input
                  className="form-check-input mr-2"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                />
                <label
                  className="form-check-label mr-3"
                  for="flexRadioDefault1"
                >
                  Crciket/fancy bet
                </label>
                <input
                  className="form-check-input mr-2"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                />
                <label
                  className="form-check-label mr-3"
                  for="flexRadioDefault1"
                >
                  Crciket/fancy1 bet
                </label>
                <input
                  className="form-check-input mr-2"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                />
                <label
                  className="form-check-label mr-3"
                  for="flexRadioDefault1"
                >
                  Book Cricket
                </label>
                <input
                  className="form-check-input mr-2"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                />
                <label
                  className="form-check-label mr-3"
                  for="flexRadioDefault1"
                >
                  Toss
                </label>
                <input
                  className="form-check-input mr-2"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                />
                <label
                  className="form-check-label mr-3"
                  for="flexRadioDefault1"
                >
                  Int Casino
                </label>
                <input
                  className="form-check-input mr-2"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                />
                <label
                  className="form-check-label mr-3"
                  for="flexRadioDefault1"
                >
                  AWC casino
                </label>
                <input
                  className="form-check-input mr-2"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                />
                <label
                  className="form-check-label mr-3"
                  for="flexRadioDefault1"
                >
                  Premium Fancy
                </label>
                <input
                  className="form-check-input mr-2"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                />
                <label
                  className="form-check-label mr-3"
                  for="flexRadioDefault1"
                >
                  Other Crciket
                </label>
                <input
                  className="form-check-input mr-2"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                />
                <label
                  className="form-check-label mr-3"
                  for="flexRadioDefault1"
                >
                  Other Soccers
                </label>
              </div>
              <div className="px-5 py-3">
                <label htmlFor="" className="mr-3">
                  Order of display:
                </label>
                <select
                  name=""
                  id=""
                  className="w-[120px] border-1 border-black"
                >
                  <option value="">Stake</option>
                  <option value="">Player ID</option>
                  <option value="">Time</option>
                </select>
                <label htmlFor="" className="mr-3 ml-3">
                  Of:
                </label>
                <select
                  name=""
                  id=""
                  className="w-[120px] border-1 border-black"
                >
                  <option value="">Accending</option>
                  <option value=""> Deccending</option>
                </select>
                <label htmlFor="" className="mr-3 ml-3">
                  Last:
                </label>
                <select
                  name=""
                  id=""
                  className="w-[120px] border-1 border-black"
                >
                  <option value="">100 Txn</option>
                  <option value=""> 50 Txn</option>
                  <option value=""> 25 Txn</option>
                </select>
                <label htmlFor="" className="mr-3 ml-3">
                  Auto Refresh seconds:
                </label>
                <select
                  name=""
                  id=""
                  className="w-[120px] border-1 border-black"
                >
                  <option value="">15</option>
                  <option value=""> 60 </option>
                  <option value=""> 30</option>
                  <option value=""> 2</option>
                  <option value=""> 5</option>
                  <option value=""> Stop</option>
                </select>
                <label htmlFor="" className="mr-3 ml-3">
                  Bet status:
                </label>
                <select
                  name=""
                  id=""
                  className="w-[120px] border-1 border-black"
                >
                  <option value="">All</option>
                </select>
                <button className="bg-yellow-500 mr-2 ml-3 rounded text-black font-bold py-1 px-3">
                  Refresh
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Abetlistlive;
